/* PAMÉ — Subscription = 2 boxes / month.
   When a subscription selling plan is selected on the product page,
   force quantity to 2 and lock it; restore for one-time purchase. */
(function () {
  function qtyInput() {
    return document.querySelector('.product__info-container .quantity__input, .product-form .quantity__input, .quantity__input');
  }
  function sellingPlan() {
    var el = document.querySelector('input[name="selling_plan"]');
    return el && el.value ? String(el.value).trim() : '';
  }
  var note = null;
  function noteHTML() {
    var src = document.getElementById('pame-sub-note-src');
    var html = src ? src.innerHTML.trim() : '';
    return html || '1ヶ月分のご利用目安として、毎月2箱をお届けします。';
  }
  function ensureNote(wrap) {
    if (note && document.body.contains(note)) return note;
    note = document.createElement('p');
    note.className = 'pame-sub-note';
    note.innerHTML = noteHTML();
    note.style.display = 'none';
    if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(note, wrap.nextSibling);
    return note;
  }
  function apply() {
    var input = qtyInput();
    if (!input) return;
    var wrap = input.closest('.quantity');
    ensureNote(wrap);
    var isSub = sellingPlan() !== '';
    if (isSub) {
      if (input.value !== '2') {
        input.value = '2';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      input.setAttribute('readonly', '');
      input.setAttribute('min', '2');
      if (wrap) wrap.classList.add('pame-qty-locked');
      if (note) note.style.display = 'block';
    } else {
      input.removeAttribute('readonly');
      input.setAttribute('min', '1');
      if (wrap) wrap.classList.remove('pame-qty-locked');
      if (note) note.style.display = 'none';
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.name === 'selling_plan' ||
        (t.type === 'radio' && (t.closest('.shopify_subscriptions_app_container') || (t.className && t.className.indexOf && t.className.indexOf('one_time_purchase_option_app_block') > -1)))) {
      setTimeout(apply, 40);
    }
  });
  var last = null;
  setInterval(function () {
    var v = sellingPlan();
    if (v !== last) { last = v; apply(); }
  }, 400);
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);

  /* Hard guarantee: at add-to-cart submit, if a subscription plan is
     selected, force quantity to 2 so the contract is created with 2 boxes. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var sp = form.querySelector('input[name="selling_plan"]');
    if (sp && sp.value && String(sp.value).trim() !== '') {
      /* In this theme the quantity input lives OUTSIDE the form (associated
         via the `form` attribute), so fall back to the global input. */
      var q = form.querySelector('input[name="quantity"], .quantity__input')
            || qtyInput();
      if (q && q.value !== '2') q.value = '2';
    }
  }, true);

  /* Same guard for accelerated / dynamic checkout buttons (Shop Pay 等),
     which submit on click before the form 'submit' event may run. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.shopify-payment-button, [data-shopify="payment-button"]')) return;
    if (sellingPlan() === '') return;
    var input = qtyInput();
    if (input && input.value !== '2') {
      input.value = '2';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);
})();
